import { IScrollablePaneProps, ScrollablePane as FluentScrollablePane, ScrollbarVisibility } from "@fluentui/react";
import React from "react";

export type ScrollablePaneProps = Pick<IScrollablePaneProps, "children" | "styles">;

export const ScrollablePane: React.FunctionComponent<ScrollablePaneProps> = (props: ScrollablePaneProps) => {
    return <FluentScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>{props.children}</FluentScrollablePane>;
};
